import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { gotItClicked, tooltipsSkipped } from '../../store/tooltips/actions';
import { TOOLTIPS, PAGE_STEPS_NUMBER } from './constants';
import OnboardingTooltip from './onboarding-tooltip/OnboardingTooltip';
import TooltipPortal from './tooltip-portal/TooltipPortal';

const OnboardingTooltipContainer = ({
    page,
    section,
    shouldMove = true,
    steps,
    skipped,
    gotItClicked,
    skipTooltips
}) => {
    const [tooltip, setTooltip] = useState(null);

    const allStepsNumber = TOOLTIPS[page][PAGE_STEPS_NUMBER];

    useEffect(() => {
        const getPositionValue = (element, position, move, adjust) => {
            let newPosition = element.getBoundingClientRect()[position];
            if (move && shouldMove) {
                newPosition -= element.getBoundingClientRect()[move];
            }
            if (adjust) {
                newPosition += adjust;
            }
            return newPosition;
        };
        if (skipped) {
            setTooltip(null);
            return;
        }
        const { tooltipId, text, position, arrowPosition, move = {}, adjust = {} } = TOOLTIPS[page][section]
            .find(tooltip => tooltip.step === steps[page]) || {};
        const tooltipParentElement = document.querySelector(`[tooltip-id=${tooltipId}]`);
        if (!tooltipParentElement) {
            setTooltip(null);
            return;
        }
        setTooltip({
            top: getPositionValue(tooltipParentElement, position.y, move.y, adjust.y),
            left: getPositionValue(tooltipParentElement, position.x, move.x, adjust.x),
            text,
            arrowPosition,
            step: steps[page]
        });
    }, [steps, skipped, page, section, shouldMove]);

    return (
        tooltip
            ? (
                <TooltipPortal>
                    <OnboardingTooltip
                        onGotItClicked={gotItClicked({ page, steps })}
                        onSkipClicked={skipTooltips({ steps })}
                        tooltip={tooltip}
                        allStepsNumber={allStepsNumber}
                    />
                </TooltipPortal>
            )
            : null
    );
};

const mapStateToProps = ({
    tooltipsReducer: { steps, skipped }
}) => ({
    steps,
    skipped
});

const mapDispatchToProps = dispatch => ({
    gotItClicked: ({ page, steps }) => () => gotItClicked(dispatch, { page, steps }),
    skipTooltips: steps => () => tooltipsSkipped(dispatch, steps)
});

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingTooltipContainer);
